(() => {
  const initialize = (bar) => {
    if (bar.dataset.salarReady === 'true') return;
    const id = bar.dataset.sectionId;
    const section = document.getElementById('MainProduct-' + id);
    if (!section) return;
    bar.dataset.salarReady = 'true';
    const stickyButton = bar.querySelector('[data-sticky-submit]');
    const price = bar.querySelector('[data-sticky-price]');
    const qty = bar.querySelector('[data-sticky-qty]');
    const originalButton = () => document.getElementById('ProductSubmitButton-' + id);
    const form = () => document.getElementById('product-form-' + id);
    const sourceQty = () => section.querySelector('input.quantity__input[name="quantity"]');
    let submitting = false;
    let queued = false;
    function sync() {
      const original = originalButton();
      const formNode = form();
      if (!original || !formNode) {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
        return;
      }
      const unavailable = original.disabled || original.getAttribute('aria-disabled') === 'true';
      stickyButton.disabled = unavailable || submitting;
      const originalLabel = original.querySelector('span:not(.sold-out-message)');
      if (originalLabel && originalLabel.textContent.trim()) stickyButton.textContent = originalLabel.textContent.trim();
      const input = sourceQty();
      if (input && document.activeElement !== qty) {
        qty.value = input.value || '1';
        qty.min = input.min || '1';
        qty.max = input.max || '';
        qty.step = input.step || '1';
      }
      const sourcePrice = section.querySelector('#price-' + id + ' .price');
      if (sourcePrice && sourcePrice.textContent.trim()) price.textContent = sourcePrice.textContent.trim();
      // Visible immediately when the original Add to Cart button has scrolled ABOVE viewport.
      const buttonRect = original.getBoundingClientRect();
      const show = buttonRect.bottom <= 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
    }
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; sync(); });
    }
    function updateQuantity() {
      const native = sourceQty();
      const step = Math.max(1, Number(qty.step) || 1);
      const min = Math.max(1, Number(qty.min) || 1);
      const max = qty.max ? Number(qty.max) : Infinity;
      const value = Math.min(max, Math.max(min, Number(qty.value) || min));
      qty.value = String(value);
      if (native) {
        native.value = String(value);
        native.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        const productForm = form();
        if (!productForm) return;
        let hidden = productForm.querySelector('[name="quantity"]');
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden'; hidden.name = 'quantity';
          productForm.appendChild(hidden);
        }
        hidden.value = String(value);
      }
    }
    qty.addEventListener('change', () => { updateQuantity(); schedule(); });
    bar.querySelectorAll('[data-qty-change]').forEach((control) => control.addEventListener('click', () => {
      qty.value = String((Number(qty.value) || 1) + Number(control.dataset.qtyChange) * (Number(qty.step) || 1));
      updateQuantity();
      schedule();
    }));
    stickyButton.addEventListener('click', () => {
      const native = originalButton();
      if (!native || native.disabled || native.getAttribute('aria-disabled') === 'true' || submitting) return;
      updateQuantity();
      // Native click triggers Dawn product-form AJAX handling, cart drawer rendering,
      // validation, variant ID, errors and all theme event subscribers.
      submitting = true;
      stickyButton.disabled = true;
      native.click();
      // Product form resets aria-disabled once the request completes.
      // Observe that state below, without issuing a second cart request.
      setTimeout(() => { submitting = false; schedule(); }, 900);
    });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    section.addEventListener('change', schedule);
    const observer = new MutationObserver(schedule);
    observer.observe(section, { subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'value'], childList: true });
    sync();
  };
  const boot = () => document.querySelectorAll('.salar-sticky-atc').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
